import RolesUtil from 'permissions/utils/roles';
const AuditChecklistPermissions = {
  canModifyChecklist: (stateData, projectID) =>
    RolesUtil.doesUserHaveCoeRoleForProject(stateData, projectID),
};

export default AuditChecklistPermissions;
